import React, { useState, useEffect } from 'react';
import { Row, Col, Breadcrumb, Card, Table, Form, CardBody, CardFooter } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import axios from 'axios';
import config from '../../config';
import '../../assets/css/verify.css';
import { useAuth } from '../../context/AuthContext';
import nouserimg from '../../assets/images/no_user.png';
const UpdateDesignation = () => {
    const { accessToken } = useAuth();
    const [employees, setEmployees] = useState([]);
    const [roles, setRoles] = useState([]);
    const [editRowId, setEditRowId] = useState(null);
    const [editedRole, setEditedRole] = useState("");
    const [editedDesignation, setEditedDesignation] = useState("");
    const [editedEmployeeId, setEditedEmployeeId] = useState("");

    // Fetch employees
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/promotion/users_verified`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                setEmployees(response.data.users);
            } catch (error) {
                console.error('Error fetching employees:', error);
            }
        };
        fetchEmployees();
    }, [accessToken]);

    // Fetch roles
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/promotion/allroles`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                setRoles(response.data.data);
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };
        fetchRoles();
    }, [accessToken]);

    // Handle edit click
    const handleEditClick = (employee) => {
        setEditRowId(employee.user_id);
        setEditedRole(employee.Role_id);
        setEditedDesignation(employee.Designation || "");
        setEditedEmployeeId(employee.userDetails?.employee_id || "");
    };

    // Handle save click
    const handleSaveClick = async () => {
        try {
            const selectedRole = roles.find(role => role.Role_id === editedRole);

            if (!selectedRole) {

                return;
            }

            await axios.post(
                `${config.apiBASEURL}/promotion/promotion-users`,
                {
                    user_id: editRowId,
                    user_type: selectedRole.role_name,
                    designation: editedDesignation,
                    employeeId: editedEmployeeId,
                },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );

            // Update UI locally
            setEmployees((prev) =>
                prev.map((emp) =>
                    emp.user_id === editRowId
                        ? {
                            ...emp,
                            Role_id: selectedRole.Role_id,
                            Designation: editedDesignation,
                            userDetails: {
                                ...emp.userDetails,
                                employee_id: editedEmployeeId,
                            },
                        }
                        : emp
                )
            );

            setEditRowId(null);
        } catch (error) {
            console.error('Error saving changes:', error);

        }
    };

    // Handle cancel click
    const handleCancelClick = () => {
        setEditRowId(null);
        setEditedRole("");
        setEditedDesignation("");
        setEditedEmployeeId("");
    };

    // Handle role change
    const handleRoleChange = (e) => {
        setEditedRole(Number(e.target.value));
    };

    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col md={6} lg={6} className="mb-4">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Role Assig</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Card className="pt-2 mt-4">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h6>Total: <b className="text-danger h6">{employees.length}</b> <small className="text-muted">Employees</small></h6>
                        </Card.Header>
                        <CardBody className="empRolltable">
                            <Table responsive size="sm" striped>
                                <thead>
                                    <tr>

                                        <th>Employee ID</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Joining Date</th>
                                        <th>System Role</th>
                                        <th>Designation</th>

                                        <th style={{ width: '150px' }} className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employees.map((employee) => (
                                        <tr key={employee.user_id}>

                                            <td>{editRowId === employee.user_id ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editedEmployeeId}
                                                    onChange={(e) => setEditedEmployeeId(e.target.value)}
                                                />
                                            ) : (
                                                employee.userDetails?.employee_id || "N/A"
                                            )}</td>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                                    <Avatar
                                                        image={employee.profileImage?.image_url || nouserimg}
                                                        shape="circle"
                                                        size="large"
                                                        className='me-2'
                                                    />
                                                    <span className='h6 mb-0'>{`${employee.first_name} ${employee.last_name}`}</span>
                                                </div>
                                            </td>
                                            <td>{employee.email}</td>
                                            <td>{new Date(employee.joiningDates?.[0]?.joining_date).toLocaleDateString('en-GB') || "N/A"}</td>
                                            <td>
                                                {editRowId === employee.user_id ? (
                                                    <select
                                                        value={editedRole}
                                                        onChange={handleRoleChange}
                                                        className="form-control form-select"
                                                    >
                                                        {roles.map((role) => (
                                                            <option key={role.Role_id} value={role.Role_id}>
                                                                {role.role_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    roles.find(role => role.Role_id === employee.Role_id)?.role_name || "N/A"
                                                )}
                                            </td>
                                            <td>{editRowId === employee.user_id ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editedDesignation}
                                                    onChange={(e) => setEditedDesignation(e.target.value)}
                                                />
                                            ) : (
                                                employee.Designation || "N/A"
                                            )}</td>

                                            <td className="text-center">
                                                {editRowId === employee.user_id ? (
                                                    <>
                                                        <Button
                                                            className="border-0"
                                                            severity="success"
                                                            onClick={handleSaveClick}
                                                            icon="pi pi-save"
                                                            outlined
                                                            title="Save"
                                                        />
                                                        <Button
                                                            className="border-0"
                                                            title="Cancel"
                                                            severity="danger"
                                                            onClick={handleCancelClick}
                                                            outlined
                                                            icon="pi pi-times"
                                                        />
                                                    </>
                                                ) : (
                                                    <Button
                                                        className="border-0"
                                                        icon="pi pi-pencil"
                                                        outlined
                                                        severity="help"
                                                        title="Edit"
                                                        onClick={() => handleEditClick(employee)}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter></CardFooter>
                    </Card>
                </Row>
            </Row>
        </>
    );
};

export default UpdateDesignation;
